import { Icon, IconProps } from "./Icon";

export function IconCircleWheelchair(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M11.55 1a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5m0-1a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5Zm8.14 22-3.26-6h-4.71A2.66 2.66 0 0 1 9 13.26V6.42l.32-.11a7.61 7.61 0 0 1 2.1-.3A2.52 2.52 0 0 1 14 8.39V12h4.53a1 1 0 0 1 .9.54l4.56 8-.88.48-4.56-8H14a1 1 0 0 1-1-1V8.39A1.51 1.51 0 0 0 11.46 7a6.39 6.39 0 0 0-1.46.18v6.08a1.76 1.76 0 0 0 .16.75 1.7 1.7 0 0 0 1.55 1h4.72a1 1 0 0 1 .88.53l3.26 6.08ZM13 17a6 6 0 1 1-6.17-6H7V7a1 1 0 0 0-1-1H4v1h2v3.06A7 7 0 1 0 14 17Z" />
    </Icon>
  );
}
